<div id="brand-settings" class="settings-page-container">
  <div class="settings-page-body">
    <!-- The preview comes first in the DOM so it stacks on top on mobile and at 400% zoom. -->
    <div
      class="tw-flex tw-flex-col tw-gap-6 tw-w-full tw-max-w-[1040px] tw-mx-auto md:tw-flex-row-reverse md:tw-items-start"
    >
      <aside
        class="tw-flex-none md:tw-basis-[360px] md:tw-sticky md:tw-top-0"
        aria-labelledby="brand-settings-preview-title"
      >
        <h2
          id="brand-settings-preview-title"
          class="tw-text-base tw-font-semibold tw-mt-0 tw-mb-2 tw-break-words"
        >
          {{ companyName }}
        </h2>
        <div
          id="brand-settings-preview"
          class="tw-flex tw-items-center tw-justify-center tw-aspect-video tw-rounded-lg tw-bg-gray-100 tw-border tw-border-solid tw-border-gray-200 tw-text-gray-700"
        >
          Brand preview
        </div>
      </aside>

      <div class="tw-flex tw-flex-col tw-gap-6 tw-flex-1 tw-min-w-0">
        <section
          id="brand-settings-logo"
          class="settings-page-section"
          aria-labelledby="brand-settings-logo-title"
        >
          <h2
            id="brand-settings-logo-title"
            class="tw-text-base tw-font-semibold tw-mt-0 tw-mb-2"
          >
            Logo
          </h2>
          <p class="tw-text-gray-600 tw-m-0">
            Logos apply to presentations automatically, and changing it will
            update current presentations that include the logo component.
          </p>

          <div
            class="tw-flex tw-flex-col tw-gap-4 tw-mt-4 sm:tw-flex-row sm:tw-items-center"
          >
            <div
              id="brand-settings-logo-thumbnail"
              class="tw-flex tw-flex-none tw-items-center tw-justify-center tw-w-40 tw-h-24 tw-p-2 tw-box-border tw-rounded-lg tw-bg-gray-100 tw-border tw-border-solid tw-border-gray-200 tw-overflow-hidden"
            >
              @if (logo(); as logo) {
                <img
                  [src]="logo.thumbnailUrl"
                  [alt]="'Logo: ' + logoFileName()"
                  class="tw-max-w-full tw-max-h-full tw-object-contain"
                />
              } @else {
                <span class="tw-text-gray-700">No logo</span>
              }
            </div>

            <div class="tw-flex tw-flex-col tw-gap-2 tw-min-w-0">
              @if (logo()) {
                <p
                  id="brand-settings-logo-name"
                  class="tw-m-0 tw-font-semibold tw-break-all"
                >
                  {{ logoFileName() }}
                </p>
              }
              <div class="tw-flex tw-flex-wrap tw-gap-2">
                <button
                  #logoUploadButton
                  rv-button
                  id="brand-settings-logo-upload"
                  type="button"
                  [loading]="isLogoUploading()"
                  (click)="uploadLogo()"
                >
                  {{ logo() ? 'Replace Logo' : 'Upload a Logo' }}
                </button>
                <button
                  rv-button
                  variant="secondary"
                  id="brand-settings-logo-storage"
                  type="button"
                  [disabled]="isLogoUploading()"
                  (click)="selectLogoFromStorage()"
                >
                  Select from Storage
                </button>
                @if (logo()) {
                  <button
                    rv-button
                    variant="tertiary"
                    id="brand-settings-logo-remove"
                    type="button"
                    [disabled]="isLogoUploading()"
                    (click)="removeLogo()"
                  >
                    Remove Logo
                  </button>
                }
              </div>
            </div>
          </div>

          <input
            #logoInput
            id="brand-settings-logo-input"
            type="file"
            class="tw-hidden"
            tabindex="-1"
            aria-hidden="true"
            [attr.accept]="logoAcceptedTypes"
            (change)="onLogoFileSelected()"
          />

          <p class="tw-sr-only" aria-live="polite">
            {{ isLogoUploading() ? 'Uploading logo' : '' }}
          </p>
          @if (logoUploadFailed()) {
            <p
              id="brand-settings-logo-error"
              role="alert"
              class="tw-text-red-800 tw-mt-2 tw-mb-0"
            >
              Your logo couldn't be uploaded. Please try again.
            </p>
          }
        </section>

        <section
          id="brand-settings-colors"
          class="settings-page-section"
          aria-labelledby="brand-settings-colors-title"
        >
          <h2
            id="brand-settings-colors-title"
            class="tw-text-base tw-font-semibold tw-mt-0 tw-mb-2"
          >
            Colors
          </h2>
          <p class="tw-text-gray-600 tw-m-0">
            Brand colors apply to presentations automatically, and changing them
            will update presentations with branding colors enabled.
          </p>
        </section>
      </div>
    </div>
  </div>
</div>
